// src/api/lessons.ts

import { apiClient } from './client';
import { Lesson, ApiResponse, CreateLessonDto, UpdateLessonSeriesDto } from '../types';

export const lessonsApi = {
    // Получить все уроки (для TEACHER/ADMIN)
    getAll: async (): Promise<ApiResponse<Lesson[]>> => {
        return apiClient.get<Lesson[]>('/lessons');
    },

    // Получить уроки конкретного ученика (для TEACHER/ADMIN)
    getByStudent: async (studentId: number): Promise<ApiResponse<Lesson[]>> => {
        return apiClient.get<Lesson[]>(`/lessons/student/${studentId}`);
    },

    /**
     * Получить уроки для текущего студента (только для роли STUDENT)
     * Использует защищённый эндпоинт /api/for-student/lessons/student/{studentId}
     */
    getForStudent: async (studentId: number): Promise<ApiResponse<Lesson[]>> => {
        return apiClient.get<Lesson[]>(`/for-student/lessons/student/${studentId}`);
    },


    // Получить уроки за период
    getByPeriod: async (startDate: string, endDate: string, timezone?: string): Promise<ApiResponse<Lesson[]>> => {
        let url = `/lessons/period?start=${startDate}&end=${endDate}`;
        if (timezone) {
            url += `&timezone=${encodeURIComponent(timezone)}`;
        }
        return apiClient.get<Lesson[]>(url);
    },

    // Получить уроки для группы
    getByGroup: async (groupId: number): Promise<ApiResponse<Lesson[]>> => {
        return apiClient.get<Lesson[]>(`/lessons/group/${groupId}`);
    },

    // Получить урок по ID
    getById: async (id: number): Promise<ApiResponse<Lesson>> => {
        return apiClient.get<Lesson>(`/lessons/${id}`);
    },

    // Создать новый урок
    create: async (data: CreateLessonDto): Promise<ApiResponse<Lesson>> => {
        return apiClient.post<Lesson>('/lessons', data);
    },

    // Обновить урок
    update: async (id: number, data: Partial<CreateLessonDto>): Promise<ApiResponse<Lesson>> => {
        console.log('=== lessonsApi.update ===');
        console.log('data =', JSON.stringify(data, null, 2));
        console.log('data.repeat =', (data as any).repeat);
        return apiClient.put<Lesson>(`/lessons/${id}`, data);
    },

    // Удалить урок
    delete: async (id: number): Promise<ApiResponse<void>> => {
        return apiClient.delete<void>(`/lessons/${id}`);
    },

    // Обновить серию
    updateSeries: async (
        seriesId: number,
        data: UpdateLessonSeriesDto
    ): Promise<ApiResponse<any>> => {
        return apiClient.put<any>(`/lessons/series/${seriesId}`, data);
    },

    // Удалить серию
    deleteSeries: async (
        seriesId: number,
        onlyFuture: boolean = true
    ): Promise<ApiResponse<{ deletedCount: number }>> => {
        return apiClient.delete<{ deletedCount: number }>(
            `/lessons/series/${seriesId}?onlyFuture=${onlyFuture}`
        );
    },
};